import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";

import DataTable from "../../components/Table/DataTable";
import SearchBox from "./../../components/SearchBox/SearchBox";

import {
  getSends,
  getSendsBySearch,
  getSendsByOrder,
} from "../../services/send";
import { showAlert } from "../../store/ducks/alert";

import { CircularProgress } from "@material-ui/core";

const Send = ({ location, match }) => {
  const dispatch = useDispatch();
  const [sends, setSends] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: "",
    search: "",
  });
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({
    item: "",
    direction: "",
  });

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: "",
        search: "",
      });
    }
  }, [location]);

  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displaySends();
  }, [isSearching, isOrdering, page]);

  useEffect(() => {
    document.addEventListener("keydown", escape, false);

    return () => {
      document.removeEventListener("keydown", escape, false);
    };
  }, []);

  const escape = useCallback((event) => {
    if (event.keyCode === 27) {
      handleSubmitSearch({
        searchItem: "",
        search: "",
      });
      window.history.pushState(
        { searching: true },
        "Searching",
        "/" + window.location.href.split("/")[3]
      );
    }
  }, []);

  const handleSubmitSearch = (searchBox) => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(!isSearching);
  };

  const headers = [
    "issueId",
    "bounces",
    "deliveries",
    "clicks",
    "opens",
    "spamComplaims",
    "successTime",
  ];

  const displaySends = async () => {
    try {
      setIsLoading(true);

      let sends;
      if (isSearching) {
        const { data } = await getSendsBySearch(
          searchField.searchItem,
          searchField.search
        );
        sends = data;
      } else if (isOrdering > 0) {
        const { data } = await getSendsByOrder(
          orderDirections.item,
          orderDirections.direction
        );
        sends = data;
      } else if (
        !isOrdering &&
        !isSearching &&
        Object.keys(match.params).length === 0
      ) {
        const { data } = await getSends(page);
        sends = data;
      }
      if (!sends) return;

      setSends(sends.rows);
      setTotalItems(sends.count);
      setTotalPages(sends.pages);
      setPage(sends.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", error.message));
    }
  };

  if (isLoading)
    return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Sends ({totalItems})</h1>

        <SearchBox
          selectItems={headers}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
          onKeyDown={escape}
          setIsOrdering={setIsOrdering}
        />
      </div>

      <DataTable
        head={headers}
        body={sends}
        bodyColumn={headers}
        action={true}
        linkPath={"sends"}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Send;
